import { routePage, TRoutePage } from "./app/infrastructure/services/route-service/models/route-page";

export const appConfig = {
    authType: 'token',
    centralPage_filterContentHide_time: '250ms',
    centralPage_filterContentShow_time: '250ms',
    centralPage_filterHide_time: '500ms',
    centralPage_filterShow_time: '500ms',
    centralPage_pageSlide_time: '500ms',
    centralPage_sectionDetails_width: '70%',
    centralPage_sectionTab_top: '8em',
    centralPage_slide_time: '500ms',
    controllerNameAuth: 'account',
    dropdown_buttonClose_time: '100ms',
    dropdown_buttonOpen_time: '100ms',
    logoEmail_name: 'LogoEmail',
    logoIconAppleTouch_fileName: 'apple-touch-icon.png',
    logoIconPng_fileName: 'favicon-32x32.png',
    logoIconSvg_fileName: 'favicon.svg',
    logoIcon_fileName: 'favicon.ico',
    logoThumb_name: 'Logo_thumb',
    logo_extension: '.png',
    logo_name: 'Logo',
    page_home: routePage.home,
    pager_enter_time: '500ms',
    pager_leave_time: '500ms',
    pager_size: 15,
    route_time: '500ms',
    showHide_enter_time: '500ms',
    showHide_leave_time: '500ms',
    show_enter_time: '500ms',
    show_leave_time: '100ms',
    storage_debounce_time: '500',
} as const;

export type TAppConfig = (typeof appConfig)[keyof typeof appConfig];

export interface IAppConfig {
    // [key: string]: string | number;
    [appConfig.authType]: 'session' | 'token' | null;
    [appConfig.centralPage_filterContentHide_time]: string | null;
    [appConfig.centralPage_filterContentShow_time]: string | null;
    [appConfig.centralPage_filterHide_time]: string | null;
    [appConfig.centralPage_filterShow_time]: string | null;
    [appConfig.centralPage_pageSlide_time]: string | null;
    [appConfig.centralPage_sectionDetails_width]: string | null;
    [appConfig.centralPage_sectionTab_top]: string | null;
    [appConfig.centralPage_slide_time]: string | null;
    [appConfig.controllerNameAuth]: string | null;
    [appConfig.dropdown_buttonClose_time]: string | null;
    [appConfig.dropdown_buttonOpen_time]: string | null;
    [appConfig.logoEmail_name]: string | null;
    [appConfig.logoIconAppleTouch_fileName]: string | null;
    [appConfig.logoIconPng_fileName]: string | null;
    [appConfig.logoIconSvg_fileName]: string | null;
    [appConfig.logoIcon_fileName]: string | null;
    [appConfig.logo_name]: string | null;
    [appConfig.logoThumb_name]: string | null;
    [appConfig.logo_extension]: string | null;
    [appConfig.page_home]: TRoutePage | null;
    [appConfig.pager_size]: number,
    [appConfig.pager_enter_time]: string | null;
    [appConfig.pager_leave_time]: string | null;
    [appConfig.route_time]: string | null;
    [appConfig.showHide_enter_time]: string | null;
    [appConfig.showHide_leave_time]: string | null;
    [appConfig.show_enter_time]: string | null;
    [appConfig.show_leave_time]: string | null;
    [appConfig.storage_debounce_time]: string | null;
}
